<template>
  <div id="app" :class="$store.getters.themeName">
    <!-- <img :src="icon" alt=""> -->
    <router-view />
  </div>
</template>

<script>
import { getSolutionId } from '@/utils/auth'
export default {
  name: 'App',
  mounted() {
    this.changeIcon()
  },
  methods: {
    changeIcon() {
      const favicon = document.querySelector('link[rel="shortcut icon"]')
      favicon.href = `${process.env.BASE_API}/solutions/${getSolutionId()}/images?key=3`
    }
  }
}
</script>
